angular
  .module 'filters'
  .filter 'filterInt', ->
    (value) ->
      if /^(\-|\+)?([0-9]+|Infinity)$/.test(value)
        return Number(value)
      NaN
